import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/_shared/module/material.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { AcceptUpdatedTermsComponent } from './accept-updated-terms/accept-updated-terms.component';

@NgModule({
  declarations: [
    AcceptUpdatedTermsComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatCheckboxModule,
    MatIconModule,
    MatDialogModule
  ],
  exports: [
    AcceptUpdatedTermsComponent
  ]
})
export class TermsModule { } 